import { __ } from '@wordpress/i18n';
import { createAnswerField } from './answer-field';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		shortAnswer: {
			insertShortAnswer: (attrs?: { label?: string; required?: boolean }) => ReturnType;
		};
	}
}

export const ShortAnswer = createAnswerField({
	name: 'shortAnswer',
	dataType: 'short-answer',
	typeLabel: __('Short Answer', 'allcoach'),
	previewText: __('Short answer…', 'allcoach'),
	commandName: 'insertShortAnswer',
});
